'use client'

import { useEffect } from 'react'
import * as Sentry from '@sentry/nextjs'
import './globals.css'

/**
 * Root error boundary: catches failures in the root layout itself, where no
 * app chrome or CSS tokens are guaranteed. Kept deliberately self-contained
 * (inline styles) so it renders even when the stylesheet didn't.
 */
export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    useEffect(() => {
        Sentry.captureException(error)
    }, [error])

    return (
        <html lang="en">
            <body
                style={{
                    margin: 0,
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'var(--bg-canvas)',
                    color: 'var(--text-primary)',
                    fontFamily: 'system-ui, -apple-system, "Segoe UI", sans-serif',
                }}
            >
                <main style={{ maxWidth: 420, padding: '0 24px', textAlign: 'center' }}>
                    <h1 style={{ fontSize: 24, fontWeight: 600, margin: '0 0 12px' }}>Something went wrong</h1>
                    <p style={{ lineHeight: 1.6, margin: '0 0 24px', color: 'var(--text-secondary)' }}>
                        Kehilla hit a problem it couldn&apos;t recover from. Your data is safe. Try again, and if
                        it keeps happening, email support@kehillahq.com.
                    </p>
                    <button
                        type="button"
                        onClick={reset}
                        style={{
                            minHeight: 44,
                            padding: '0 20px',
                            borderRadius: 8,
                            border: 0,
                            background: 'var(--bg-brand)',
                            color: 'var(--text-on-brand)',
                            fontSize: 15,
                            fontWeight: 600,
                            cursor: 'pointer',
                        }}
                    >
                        Try again
                    </button>
                </main>
            </body>
        </html>
    )
}
